var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body detail",on:{"scroll":_vm.stopSendingEvent}},[_c('div',{staticClass:"slider detail"},_vm._l((_vm.images),function(image,ind){return _c('img',{key:ind,staticClass:"slider-item",attrs:{"src":image}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }